import axios from "axios";

export interface UpdateTrailerNumberParams {
  transactionId: number;
  trailerNumber: string;
}

export const updateTrailerNumber = (params: UpdateTrailerNumberParams) =>
  axios.patch("transactions/updateTrailerNumber", params).then(({ data }) => data);
